import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ModalComponent, QrComponent } from '@tecalisdev/infinity';
import { TranslatePipe } from '@ngx-translate/core';
import { ConfigService } from '../../services/config/config.service';

@Component({
	selector: 'app-modal-scan-qr',
	templateUrl: './modal-scan-qr.component.html',
	styleUrls: ['./modal-scan-qr.component.scss'],
	imports: [ModalComponent, QrComponent, TranslatePipe],
})
export class ModalScanQrComponent {
	private configService = inject(ConfigService);

	@Input() isVisible: boolean = false;
	@Input() titleKey: string = 'OCR.BACK.MODAL_SCAN.TITLE';
	@Input() descriptionKey: string = 'OCR.BACK.MODAL_SCAN.DESCRIPTION';
	@Input() descriptionWithRecordingKey: string = 'OCR.BACK.MODAL_SCAN.DESCRIPTION_WITH_RECORDING';
	@Input() url: string;
	@Output() isVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	get hasActiveRecording(): boolean {
		return this.configService.getCurrentConfig()?.required_recording || false;
	}

	public closeModal(): void {
		this.isVisible = false;
		this.isVisibleChange.emit(false);
	}
}
